import React, { ComponentProps } from 'react';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { PagePropertySettingsDefaultView } from './views/PagePropertySettingsDefaultView';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type PagePropertySettingsProps = Views<DefaultView<PagePropertySettingsDefaultView>>;
function PagePropertySettings(props: PagePropertySettingsProps) {
  return <PagePropertySettingsDefaultView {...props.views.default} />;
}

export const PagePropertySettingsBlock = asFetchableBlock(PagePropertySettings, BlockType.pagepropertysettings);
export type PagePropertySettingsBlock = ComponentProps<typeof PagePropertySettingsBlock>;
